import Cookies from "js-cookie";

import { TIMEOUT_REDIRECT } from "@/shared/constants/timeout.constant";

const MAX_TIME = 6 * 60 * 60 * 1000; // exp time is 6 hours; 1000 ms = 1 second

export default {
  data() {
    return {
      events: ["mousemove", "keydown", "click", "load"],
      logoutTimer: null,
    };
  },

  async mounted() {
    //Automatic logout for external portal only
    if (!this.isInternalPortal) {
      this.automatedLogoutHandler();
    }
  },

  destroyed() {
    //Automatic logout for external portal only
    if (!this.isInternalPortal) {
      this.events.forEach((name) => {
        window.removeEventListener(name, this.checkInActivityTime, true);
      }, this);
    }
  },

  methods: {
    automatedLogoutHandler() {
      const lastRefresh = localStorage.getItem("lastRefresh");
      const currentTimestamp = this.$dateFunc({});

      if (lastRefresh && currentTimestamp.isAfter(lastRefresh)) {
        this.logout();
      } else {
        this.events.forEach((name) => {
          window.addEventListener(name, this.checkInActivityTime, true);
        }, this);
      }
    },

    logout() {
      localStorage.removeItem("lastRefresh");

      const timeoutId = setTimeout(() => {
        clearTimeout(timeoutId);
        this.$store.dispatch("app/toggleSnackBar", {
          message: "Your session is expired.",
          color: "invert-error",
          isNoSidebarToolbar: true,
        });
      }, TIMEOUT_REDIRECT);

      this.$store.dispatch("auth/authDestroy");
    },

    checkInActivityTime() {
      const updatedTime = this.$dateFunc({}).add(MAX_TIME, "ms");
      const lastRefresh = localStorage.getItem("lastRefresh");
      const currentTimestamp = this.$dateFunc({});

      clearTimeout(this.logoutTimer);
      if (Cookies.get("t")) {
        //checking condition when device is sleep mode, some how timeout doesn't run on sleep mode
        if (lastRefresh && currentTimestamp.isAfter(lastRefresh)) {
          this.logout();
        } else {
          localStorage.setItem("lastRefresh", updatedTime);
          this.logoutTimer = setTimeout(this.logout, MAX_TIME);
        }
      } else {
        this.logout();
      }
    },
  },
};
